module.exports = __webpack_public_path__ + "img/ProduktabbildungenAndLogo.4c469198.png";